import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=367b1fb3&scoped=true"
import script from "./UserHeader.vue?vue&type=script&lang=js"
export * from "./UserHeader.vue?vue&type=script&lang=js"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=367b1fb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b1fb3",
  null
  
)

export default component.exports